const dddMask = (value, previousValue) => {
  if (!value) {
    return undefined
  }

  const onlyNums = value && value.replace(/[^\d]/g, '')

  if (!value || (previousValue && value.length < previousValue.length)) {
    return onlyNums.slice(0, 1)
  }

  if (onlyNums.length < 2) {
    return onlyNums
  }

  return `(${onlyNums.slice(0, 2)})`
}

export default dddMask



// WEBPACK FOOTER //
// ./src/alelo-logic/utils/dddMask.js